export interface ENTITY_IA_CONTENT_MODAL_LABELS {
    modalTitle: string;
    modalSubtitle: string;
    modalNameLabel: string;
    modalNameHint: string;
    modalDescriptionLabel: string;
    modalDescriptionHint: string;
    useTitle?: boolean;
    entityTitle?: string;
    typePrompt: TYPE_PROMPT;
}

export enum SERVICE_TYPE {
    IA_PRODUCT_DESCRIPTION = 'ia_product_descriptions',
    IA_POST_CONTENT = 'ia_post_content',
    IA_WIZARD_GENERATION = 'ia_wizard_generation',
}

export enum TYPE_PROMPT {
    PRODUCT_CONTENT_GENERATION = 'product-content-generation',
    POST_CONTENT_GENERATION = 'post-content-generation',
}

// export interface GENERATE_IA_CONTENT_PAYLOAD {
//    typePrompt: TYPE_PROMPT
//    userPrompt: 'Tono: creativo, Longitud del texto: corto, Prompt usuario: máquina de coser automática'
//    context: 'Nombre de producto: [nombre_producto]' | 'Nombre de post: [nombre_post]'
// }

export type Tone =
    | 'formal'
    | 'amigable'
    | 'tecnico'
    | 'vendedor'
    | 'creativo'
    | 'informativo'
    | 'persuasivo'
    | 'entretenido'
    | 'analitico'
    | 'personal';
export type Length = 'corto' | 'medio' | 'largo';

export type UserPrompt<
    T extends Tone,
    L extends Length,
    U extends string
> = `Tono: ${T}, Longitud del texto: ${L}, Prompt: ${U}`;

export type Context = `Nombre de producto: ${string}` | `Nombre de post: ${string}`;

export interface GENERATE_IA_CONTENT_PAYLOAD<
    T extends Tone = Tone,
    L extends Length = Length,
    U extends string = string
> {
    typePrompt: TYPE_PROMPT;
    userPrompt: UserPrompt<T, L, U>;
    context: Context;
}
